import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Spinner from "../common/Spinner";
import Button from "../common/Button";

const STATUS_TO_DISPLAY = {
  saving: { label: "Saving", icon: <Spinner size={6} /> },
  saved: { label: "Saved", icon: <FontAwesomeIcon icon="check" size="lg" /> },
  dirty: { label: "Save", icon: <FontAwesomeIcon icon="save" size="lg" /> },
  clean: { label: "No Changes", icon: <FontAwesomeIcon icon="check" size="lg" /> },
};

export default function SectionFooter({ handleSubmit, advanceTab, advanceLabel, status }) {
  return (
    <div className="w-full flex justify-end gap-4">
      <Button
        className="gap-4"
        onClick={handleSubmit}
        disabled={status !== "dirty"}
      >
        <div className="-ml-3">{STATUS_TO_DISPLAY[status].icon}</div>
        {STATUS_TO_DISPLAY[status].label}
      </Button>
      <Button
        onClick={() => advanceTab(status === 'dirty')}
        disabled={!advanceTab || status === 'saving'}
      >
        {advanceLabel}
      </Button>
    </div>
  );
}
